import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "clearButton",
    "desktopInput",
    "fileInput",
    "summary"
  ]

  connect() {
    this.syncSummary()
  }

  open(event) {
    event.preventDefault()

    this.fileInputTarget.click()
  }

  clear(event) {
    if (event) event.preventDefault()

    this.inputs().forEach((input) => {
      input.value = ""
    })
    this.syncSummary()
  }

  syncSummary() {
    const files = this.selectedFiles()

    if (files.length === 0) {
      this.summaryTarget.textContent = "選択されていません"
      this.clearButtonTarget.hidden = true
      return
    }

    const names = files.slice(0, 2).map((file) => file.name).join("、")
    const suffix = files.length > 2 ? ` ほか${files.length - 2}枚` : ""
    this.summaryTarget.textContent = `${files.length}枚選択中：${names}${suffix}`
    this.clearButtonTarget.hidden = false
  }

  selectedFiles() {
    return this.inputs().flatMap((input) => Array.from(input.files || []))
  }

  inputs() {
    return [
      this.hasDesktopInputTarget ? this.desktopInputTarget : null,
      this.hasFileInputTarget ? this.fileInputTarget : null
    ].filter(Boolean)
  }
}
